// Link di sblocco delle novità grafiche: ?preview=v2 le mostra in questo browser, ?preview=off le nasconde di nuovo.
const PREVIEW_KEY = 'runtime.v2Preview';

/** Registra (e toglie dall'indirizzo) il parametro preview, poi dice se in questo browser le novità sono sbloccate. */
export function readV2PreviewUnlock() {
  try {
    const url = new URL(window.location.href);
    const value = url.searchParams.get('preview');
    if (value === 'v2') localStorage.setItem(PREVIEW_KEY, 'on');
    if (value === 'off') localStorage.removeItem(PREVIEW_KEY);
    if (value !== null) {
      url.searchParams.delete('preview');
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    }
    return localStorage.getItem(PREVIEW_KEY) === 'on';
  } catch (e) {
    return false;
  }
}
